// extracted by mini-css-extract-plugin
var _1 = "BreakLine_breakLine__HX-mm";
var _2 = "992px";
var _3 = "768px";
var _4 = "'../../../shared.module.css'";
export { _1 as "breakLine", _2 as "lg", _3 as "md", _4 as "shared" }
